import { defineMessages } from 'react-intl';

export default defineMessages({
  refreshPage: {
    id: 'yield-management.schedule-detail-v2.roster-v2.refresh-page',
    defaultMessage: 'Refresh page',
  },
  unableToLoadRoster: {
    id: 'yield-management.schedule-detail-v2.roster-v2.error-title',
    defaultMessage: 'Unable to load roster',
  },
  unableToLoadRosterHint: {
    id: 'yield-management.schedule-detail-v2.roster-v2.error-hint',
    defaultMessage: 'Please refresh the page to try again.',
  },
  unableToLoadRosterSupport: {
    id: 'yield-management.schedule-detail-v2.roster-v2.error-support',
    defaultMessage: 'If the problem persists, please contact <a>Partner Success</a>.',
  },
});
